export const googleMapsApiKey = 'AIzaSyB3rkKSDCLwiLP2HhsC2UQsl1n12yxty5s';
export const googleMapsId = 'efe3d90f962326df';

export const externalConfigEndpoint = 'https://www.expedia.com/eg-maps-config-service/';

export const uniqueDialogId: string = 'mapDialog';

export const searchMapDialogId = 'mapDialogLayer';
export const searchMapToolbar = 'map-toolbar';

export const dropOffMapContent = 'drop-off-map-content';
export const dropOffMapToolbar = 'drop-off-map-toolbar';
export const dropOffMapDialogLayerId = 'drop-Off-map-dialog-layer';

export const mapSearchAreaExperimentName = 'Cars_MapsSearchThisArea_EGTNL';

export const searchIcon = 'search';
export const searchMarkerId = 'LOC-';

export const zoomInAnalytics = { rfrr : 'Cars.SR.Maps.ZoomIn', link : 'click-zoom-in' };
export const zoomOutAnalytics = { rfrr : 'Cars.SR.Maps.ZoomOut', link : 'click-zoom-out' };
export const mapPanAnalytics = { rfrr : 'Cars.SR.Maps.MapPan', link : 'click-map-pan' };